import { useEffect } from 'react';
import CustomLoading from '../../components/customLoading/customLoading';
import styles from './Logout.module.scss';
import { useAuth } from 'hooks/useAuth';

function Logout() {
  const auth = useAuth();

  useEffect(() => {
    sessionStorage.clear();

    auth.logout();
  }, []);
  return (
    <div className={styles.loadingContainer}>
      <CustomLoading label='Finalizando seu logout e redirecionando para página principal da plataforma' />
    </div>
  );
}

export default Logout;
